import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargeDebtorTemplate = async ({
    token,
    places = [],
}) => {

    const params = {
        places
    }

    try {
        const res = await axiosCreate.get('/charge/debtor/template', {
            responseType: 'blob',
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        const blobFile = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        return blobFile;
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}